import React from 'react';

const Notification = () => {
    return (
        <div>
            
        </div>
    );
};

export default Notification;